import PriceSelector, { CURRENCY_KEY } from './PriceSelector';

export default PriceSelector;
export { CURRENCY_KEY };
